module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_08_sp-8111e1e2ed0edbb754aaa18520189033.png";